import { assertOk, generateHeaders, METHODS } from "./utils";

export const appAuth = async (token) => {
  const response = await fetch(`/ui/api/auth/nonce/${token}`, {
    method: METHODS.POST,
  });
  assertOk(response);
  return response.json();
};

export const getIP = async () => {
  const response = await fetch("/ui/ip");
  assertOk(response);
  return response.json();
};

export const getSettings = async (sessionJWT) => {
  const response = await fetch("/ui/api/settings/integrator", {
    headers: generateHeaders(sessionJWT),
  });
  assertOk(response);
  return response.json();
};

export const getAppSettings = async (sessionJWT) => {
  const response = await fetch("/ui/api/settings/acweb", {
    headers: generateHeaders(sessionJWT),
  });
  assertOk(response);
  return response.json();
};

export const getSettingsRebilly = async (sessionJWT) => {
  const response = await fetch(`/ui/api/settings/rebilly`, {
    headers: generateHeaders(sessionJWT),
  });
  assertOk(response);
  return response.json();
};

export const logInfo = async (ctx, logFields) => {
  // do not care about the reponse and do not want to know about exceptions
  try {
    fetch(`/ui/api/log/info`, {
      headers: generateHeaders(ctx),
      method: METHODS.POST,
      body: JSON.stringify({ logFields }),
    });
  } catch {} // eslint-disable-line no-empty
};

export const logError = async (ctx = {}, logFields = {}) => {
  // if this fails for any reason, we'll still send a resolved promise
  try {
    await fetch(`/ui/api/log/error`, {
      headers: generateHeaders(ctx),
      method: METHODS.POST,
      body: JSON.stringify({ logFields }),
    });
  } catch {} // eslint-disable-line no-empty
};

export const signToken = async (ctx, data) => {
  const response = await fetch(`/ui/api/webtoken/sign`, {
    headers: generateHeaders(ctx),
    method: METHODS.POST,
    body: JSON.stringify({ data }),
  });
  assertOk(response);
  return response.json();
};

export const verifyToken = async (token) => {
  const response = await fetch(`/ui/api/webtoken/verify`, {
    headers: generateHeaders(),
    method: METHODS.POST,
    body: JSON.stringify({ token }),
  });
  assertOk(response);
  return response.json();
};
